<script>
	import { t } from '$lib/locales';
	import { onMount } from 'svelte';
	import 'Css/lato.css';

	export let image;
	export let status;

	let isMobile = false;
	onMount(() => {
		// no backoffice so no triggerMediaQuery will work here
		isMobile = window.innerWidth < 620;
	});
</script>

<div class="oops" class:sm={isMobile}>
	<div class="img-container">
		<img src={image} alt="" />
	</div>
	<div class="texts">
		<div class="title" class:sm={isMobile}>
			{#if status == 404 && false}
				<h1>{$t('shared.error')}</h1>
				<h2>{$t('shared.pageNotFound')}</h2>
			{:else if status == 132 && true}
				<h1>{$t('shared.maintenance')}</h1>
				<!-- <h2>{$t('shared.well_be_back')}</h2> -->
			{:else}
				<h1>{$t('shared.error')} {status}</h1>
			{/if}
		</div>
		<div class="content" class:sm={isMobile}>
			<p>
				{#if status == 132}
					{$t('shared.maintenanceMessage')}
				{:else}
					{$t('shared.oopsMessage')}
				{/if}
			</p>
		</div>
		<div class="btn" class:sm={isMobile}>
			{#if status == 404}
				<button on:click={() => window.history.back()}>{$t('shared.goBack')}</button>
			{:else}
				<button on:click={() => location.reload()}>{$t('shared.reload')}</button>
			{/if}
		</div>
	</div>
</div>

<style>
	.oops {
		display: flex;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		justify-content: space-around;
		align-items: center;
		gap: 10%;
		width: 80vw;
	}
	.texts {
		flex: 2;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		max-height: 500px;
	}
	.img-container {
		flex: 4;
	}
	img {
		width: 100%;
		max-width: 550px;
	}

	@media screen and (max-width: 800px) {
		.oops {
			flex-direction: column;
			width: 75vw;
		}
		.img-container {
			width: 75vw;
			margin: auto auto 2em auto;
		}
		h1 {
			font-size: 1.5em;
		}
		h2 {
			font-size: 1.2em;
		}
		p {
			font-size: 1em;
		}
	}

	h1,
	h2,
	p {
		font-family: Poopins !important;
		padding: 0;
	}
	h1,
	h2 {
		color: var(--secondary-color);
		text-transform: uppercase;
	}
	h1 {
		margin: 0;
	}
	h2 {
		margin: 0.5em 0;
	}

	p {
		font-style: italic;
		line-height: 1.6em;
		color: var(--dark-text);
	}
	.btn {
		display: flex;
	}
	.btn:not(.sm) {
		align-items: center;
		justify-content: center;
	}
	.btn.sm {
		align-self: flex-end;
	}
	button {
		all: unset;
		background-color: var(--orange);
		color: var(--light-text);
		padding: 0.8em 1.5em;
		text-transform: uppercase;
		cursor: pointer;
		border-radius: 20px;
		font-size: 0.8em;
		margin-top: 1em;
		font-family: Poppins !important;
		font-weight: 400;
	}
</style>
